module.exports = __webpack_public_path__ + "static/media/ab.00395f16.svg";